/* global Inputmask */

document.addEventListener('turbo:load', function () {
  addMaskToContraInputs()
  addConditionalMaskToContraInputs()
  addSignPropagationEvent()
  observeContraInputs()
})

function addConditionalMaskToContraInputs(node) {
  node = typeof node !== 'undefined' ? node : document
  const selector = node.querySelectorAll('[data-input-mask=signed_decimal_if_split]')
  selector.forEach(function (element) {
    const row = element.closest('.invoice_row') || element.closest('.batch_row')
    const isSplit = row.querySelector('.is_split_field').value
    if (isSplit === 'true' || isSplit === '1') {
      addSignedMask(element)
    } else {
      Inputmask('decimal', { mask: '[9{1,10}][.][9][9]', digits: 2 }).mask(element)
    }
  })
}

function addMaskToContraInputs(node) {
  node = typeof node !== 'undefined' ? node : document
  addSignedDecimalMasks(node)
  addSignedIntegerMasks(node)
}

function addSignedDecimalMasks(node) {
  const selector = node.querySelectorAll('[data-input-mask=signed_decimal]')
  if (selector.length < 1) return
  addSignedMask(selector)
}

function addSignedMask(selector) {
  Inputmask('decimal', { mask: '[\\-][9{1,10}][.][9][9]', digits: 2 }).mask(selector)
}

function addSignedIntegerMasks(node) {
  const selector = node.querySelectorAll('[data-input-mask=signed_integer]')
  if (selector.length < 1) { return }
  Inputmask('integer', { mask: '[\\-][9{1,10}]' }).mask(selector)
}

function addSignPropagationEvent(node) {
  node = typeof node !== 'undefined' ? node : document
  const elements = node.querySelectorAll("[data-action*='unfocus->contra_form#propagateSign']")
  elements.forEach(function (element) {
    element.addEventListener('focusout', propagateSign)
  })
}

function observeContraInputs() {
  const contraFormsIds = ['invoice_form', 'bank_transaction_form']
  contraFormsIds.forEach(function (formId) {
    const targetNode = document.getElementById(formId)
    if (targetNode) {
      observerSetup(targetNode)
    }
  })
}

function propagateSign() {
  const thisNegative = this.value < 0
  const siblings = this.closest('tr').querySelectorAll('[data-input-mask=signed_decimal]')
  siblings.forEach(function (sibling) {
    if (sibling === this) { return }
    const siblingNagative = sibling.value < 0
    if (siblingNagative !== thisNegative) {
      sibling.value = (sibling.value * -1).toFixed(2)
    }
  })
}

function observerSetup(observedNode) {
  const config = { attributes: true, childList: true, subtree: true }

  const callback = function (mutationsList) {
    mutationsList.forEach(function (mutation) {
      if (mutation.type === 'attributes' && mutation.target.classList.contains('is_split_field')) {
        const row = mutation.target.closest('.invoice_row') || mutation.target.closest('.batch_row')
        addConditionalMaskToContraInputs(row)
      }
      mutation.addedNodes.forEach(function (node) {
        if (node.nodeType === 1) {
          addMaskToContraInputs(node)
          addConditionalMaskToContraInputs(node)
          addSignPropagationEvent(node)
        }
      })
    })
  }

  const observer = new MutationObserver(callback)
  observer.observe(observedNode, config)

  document.addEventListener('turbo:before-cache', function () {
    observer.disconnect()
  })
}
